import React from "react"
import Text from "components/common/Text"

const P = props => (
  <Text size="small" lineHeight="medium" weight="normal" {...props} />
)

export default P
